import { styled, useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { Spinner } from 'baseui/icon';
import { Input } from 'baseui/input';
import { useEffect, useRef, useState } from 'react';
import { VscEdit } from 'react-icons/vsc';
import { HierarchyObjectNavigation } from '../components/HierarchyNavigation'
import { useSetObjectValue } from '../hooks/useSetObjectValue';
import { BasePageLayout } from './Page/BasePageLayout';
import { FormattedMessage } from 'react-intl';

export interface NavigationPageProps {
    objectId: string,
    resourceGroupId: string,
    objectName: string,
    objectDescription: string,
    children: any
    actionButton?: any,
    showNavigateBack?: boolean | undefined,
    bottomActionButtons?: React.ReactNode | React.ReactNode[] | undefined
}

export const NavigateablePage = (props: NavigationPageProps) => {
    const [css, theme] = useStyletron();

    return (
        <BasePageLayout
            bottomActionButtons={props.bottomActionButtons}
            children={props.children}
            header={<EditableHeader {...props}></EditableHeader>}
            subheader={<HierarchyObjectNavigation className={css({ fontSize: theme.typography.ParagraphXSmall.fontSize })} resourceGroupId={props.resourceGroupId} objectId={props.objectId} currentDescription={props.objectDescription} current={props.objectName} showDescription={true} currentAsLink={false}></HierarchyObjectNavigation>} actionButton={props.actionButton}
            showNavigateBack={props.showNavigateBack}></BasePageLayout>
    )
}

const EditableHeader = (props: any) => {
    const [, theme] = useStyletron();
    const [mouseOver, setMouseOver] = useState(false);
    const inputRef = useRef<any>(null);
    const [edit, setEdit] = useState(false);
    const [value, setValue] = useState(props.objectDescription);
    const [hasChanged, setHasChanged] = useState(false);
    const [value1, setValue1, setValueResult] = useSetObjectValue(props.objectId, props.resourceGroupId, "description", props.objectDescription, 50);
    const onValueChanged = (e: any) => {
        setValue(e.target.value);
        setHasChanged(true);
    }
    const onBlur = (e: any) => {
        setEdit(false);
        if (hasChanged) {
            setHasChanged(false);
            setValue(e.target.value);
            setValue1(e.target.value);
        }
    }
    useEffect(() => {
        if (props.objectDescription) {
            setHasChanged(false);
            setValue(props.objectDescription);
        }
    }, [props.objectDescription]);

    useEffect(() => {
        if (edit)
            inputRef.current && inputRef.current.focus();
    }, [edit, inputRef]);


    const name = props.objectDescription && props.objectDescription !== "" ? props.objectDescription : props.objectName;

    return (
        <HeaderTextContainer
            onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)}>
            {setValueResult.isLoading && <Spinner />}
            <>
                {!edit  ?
                    <div>{name}</div>
                    :
                    <EditInputContainer>
                        <Input
                            size='compact'
                            inputRef={inputRef}
                            value={value}
                            onChange={onValueChanged}
                            onBlur={onBlur}
                            overrides={{
                                Input: {
                                    style: ({ $theme }) => ({
                                        //width: '100%',
                                        fontSize: theme.typography.HeadingSmall.fontSize,
                                        fontFamily: theme.typography.HeadingSmall.fontFamily,
                                    })
                                }
                            }}></Input>
                        {hasChanged && <>*</>}
                    </EditInputContainer>}
            </>
            {
                ((mouseOver )) &&
                <Button size='mini' kind='tertiary' shape='circle' isSelected={edit} onClick={() => { setEdit(!edit); }}><VscEdit /></Button>
            }
        </HeaderTextContainer >
    );
}

const HeaderTextContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gridGap: $theme.sizing.scale400
}));

const EditInputContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gridGap: $theme.sizing.scale400
}));
